/**
 * Company brand constants for the application.
 * Centralizing these values allows for easier updates and better maintainability.
 */
export const COMPANY_INFO = {
    NAME: 'Frigorífico Capriata',
    SLOGAN: 'Tradición Italiana. Calidad Artesanal.',
    FOUNDING_YEAR: 1906,
    FULL_SLOGAN: 'Excelencia en Chacinados desde 1906',
    LOCATION: 'Tres Arroyos, Buenos Aires',
    EMAILS: {
        CONTACT: 'fcapriatasa@3net.com.ar',
    },
    SOCIAL: {
        INSTAGRAM: '@frigorificocapriata',
        INSTAGRAM_URL: 'https://instagram.com/frigorificocapriata',
    }
};
